import React, { Component } from 'react';
import styled from 'styled-components';
import { checkOperationCreate } from '../../utils/OperationPermissions';
import { useHistory } from 'react-router';
import { useFullUserDetails } from '../../utils/hooks';
import { EntityType } from '../../@types/entityTypes';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

export const OptionLink = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${p4Tokens.colorNeutralForeground3};
  padding: 2px 2px;
  cursor: pointer;

  &:hover {
    background-color: #e5e5e5;
    color: #3949ab;
    text-decoration: none;
  }
`;

const PermittedLink = ({
  entity,
  requestClose,
  title,
}: {
  requestClose: () => void;
  entity: EntityType;
  title?: string;
}) => {
  const history = useHistory();
  const fullUserDetails = useFullUserDetails();
  const onClick = () => {
    history.push({
      pathname: `${entity.formUrl}New`,
      state: { previousLocation: history.location?.pathname || 'back' },
    });
    requestClose();
  };

  const permitted = checkOperationCreate({ entity: entity, app: { fullUserDetails } });
  if (!permitted || !entity) return null;

  return <OptionLink onClick={onClick}>{title || entity.formTitle}</OptionLink>;
};

export default PermittedLink;
